
(function () {
  const questions = [
    {
      title: "Your perfect weekend?",
      answers: [
        ["A weekend upstate, boots included", "country"],
        ["Dinner and drinks in the city", "city"],
        ["A beach day with nowhere to be", "beach"],
        ["Coffee, errands, and a slow Sunday", "simple"]
      ]
    },
    {
      title: "Pick your dream wardrobe.",
      answers: [
        ["Vintage denim, boots, and worn-in leather", "country"],
        ["A statement outfit with the perfect accessories", "city"],
        ["Linen, breezy layers, and sun-kissed gold", "beach"],
        ["Great basics and timeless pieces", "simple"]
      ]
    },
    {
      title: "Your jewelry philosophy?",
      answers: [
        ["A little nostalgic, a little playful", "country"],
        ["The more personality, the better", "city"],
        ["Collected on vacation, worn year-round", "beach"],
        ["Simple pieces, everyday wear", "simple"]
      ]
    }
  ];

  const results = {
    country: {
      title: "The Country Girl",
      description: "A little nostalgic, a little wild at heart. Think vintage denim, weekend escapes, and charms with a story to tell.",
      url: "/collections/the-country-girl"
    },
    city: {
      title: "The City Girl",
      description: "You've got places to be and outfits to plan. Your style is confident, playful, and never short on personality.",
      url: "/collections/the-it-girl"
    },
    beach: {
      title: "The Beachy Girl",
      description: "Sun on your skin, salt in your hair, and nowhere you'd rather be. You love easygoing pieces with a little coastal nostalgia.",
      url: "/collections/the-beachy-girl"
    },
    simple: {
      title: "The Simple Girl",
      description: "Understated never means boring. You know the power of a great basic and a perfectly chosen detail.",
      url: "/collections/the-simple-girl"
    }
  };

  function initQuiz(root) {
    if (root.dataset.quizReady === "true") return;

    const questionScreen = root.querySelector(
      "[data-vibe-question-screen]"
    );
    const questionTitle = root.querySelector(
      "[data-vibe-question]"
    );
    const answersContainer = root.querySelector(
      "[data-vibe-answers]"
    );
    const count = root.querySelector("[data-vibe-count]");
    const fill = root.querySelector("[data-vibe-fill]");
    const back = root.querySelector("[data-vibe-back]");
    const resultScreen = root.querySelector("[data-vibe-result]");
    const restart = root.querySelector("[data-vibe-restart]");

    if (
      !questionScreen || !questionTitle ||
      !answersContainer || !count || !fill ||
      !back || !resultScreen || !restart
    ) return;

    root.dataset.quizReady = "true";

    let current = 0;
    let selections = [];

    function renderQuestion() {
      questionScreen.hidden = false;
      resultScreen.hidden = true;

      const question = questions[current];

      questionTitle.textContent = question.title;

      count.textContent =
        String(current + 1).padStart(2, "0") +
        " / 03";

      fill.style.width =
        ((current + 1) / 3 * 100) + "%";

      answersContainer.replaceChildren();

      question.answers.forEach(([label, vibe]) => {
        const button = document.createElement("button");

        button.type = "button";
        button.className = "cc-vibe__answer";
        button.textContent = label;

        button.addEventListener("click", () => {
          selections[current] = vibe;

          if (current < 2) {
            current++;
            renderQuestion();
          } else {
            renderResult();
          }
        });

        answersContainer.appendChild(button);
      });

      back.hidden = current === 0;
    }

    function renderResult() {
      const scores = {
        country: 0,
        city: 0,
        beach: 0,
        simple: 0
      };

      selections.forEach(vibe => {
        scores[vibe]++;
      });

      const highest = Math.max(...Object.values(scores));

      const tied = Object.keys(scores).filter(
        vibe => scores[vibe] === highest
      );

      const winner = [...selections].reverse().find(
        vibe => tied.includes(vibe)
      );

      const result = results[winner];

      questionScreen.hidden = true;
      resultScreen.hidden = false;

      count.textContent = "YOUR RESULT";
      fill.style.width = "100%";

      root.querySelector("[data-vibe-title]").textContent =
        result.title;

      root.querySelector("[data-vibe-description]").textContent =
        result.description;

      root.querySelector("[data-vibe-link]").href =
        result.url;
    }

    back.addEventListener("click", () => {
      if (current > 0) {
        current--;
        selections = selections.slice(0, current);
        renderQuestion();
      }
    });

    restart.addEventListener("click", () => {
      current = 0;
      selections = [];
      renderQuestion();
    });

    renderQuestion();
  }

  function initAllQuizzes() {
    document.querySelectorAll("[data-vibe-quiz]").forEach(
      initQuiz
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initAllQuizzes
    );
  } else {
    initAllQuizzes();
  }

  // Reinitialize after Shopify theme-editor section reloads.
  document.addEventListener(
    "shopify:section:load",
    initAllQuizzes
  );
})();
